import { useTanstackQuery } from '@core/hooks/useTanstackQuery';
import { abcloudzFlowChatMutation } from '../mutations/abcloudzFowChat.mutation';

const useAbcloudzFlowChatSessions = () => {
  const getSessionsWithAutoCreate = useTanstackQuery({
    instance: abcloudzFlowChatMutation.getSessionsWithAutoCreate$
  });

  const createSession = useTanstackQuery({
    instance: abcloudzFlowChatMutation.createSession$
  });

  const abortSession = useTanstackQuery({
    instance: abcloudzFlowChatMutation.abortSession$
  });

  return {
    getSessionsWithAutoCreate,
    createSession,
    abortSession
  };
};

export default useAbcloudzFlowChatSessions;
